export default __webpack_public_path__ + "static/media/check.dbbd0d03.svg";